import React, { Fragment, FunctionComponent, useContext, useEffect, useState } from 'react';
import ChristianFinancialResoucesTheme from './ChristianFinancialResources';
import ChurchinvestorsFundTheme from './ChurchInvestorsFund/ChurchInvestorsFundTheme';
import WatersEdgeTheme from './WatersEdge';

interface IProps {
  theme:string;
  resetApp():void;
}


const Theme:FunctionComponent<IProps> = props => {

  return (
    <Fragment> 
        {props.theme === 'cif' &&
            <ChurchinvestorsFundTheme resetApp={props.resetApp}>
                {props.children}
            </ChurchinvestorsFundTheme>
        }
        {props.theme === 'cfr' &&
            <ChristianFinancialResoucesTheme resetApp={props.resetApp}>
                {props.children}
            </ChristianFinancialResoucesTheme>
        }
        {props.theme === 'watersedge' &&
            <WatersEdgeTheme resetApp={props.resetApp}>
                {props.children}
            </WatersEdgeTheme>
        }
    </Fragment>
    )
}

export default Theme;